module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"selectTransitions":"Select Transitions","selectTransitionsHint":"Add this element to all the selected transitions"},"fr":{"selectTransitions":"Choisir les transitions","selectTransitionsHint":"Ajouter cet élément à toutes les transitions choisies"}}')
  delete Component.options._Ctor
}
